import A from 'const/actionTypes'
import actions from '.'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

export default {
  clearScores: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_SCORES, })
    }
  },
  deleteScores: (gamerId) => {
    return (dispatch, getState) => {
      const path = `scores/${gamerId}`
      firebaseService.off(
        path,
        N.GAMERS,
      )
      dispatch({
        type: A.DELETE_SCORES,
        gamerId,
      })
    }
  },
  saveScore: (updatedScore) => {
    return (dispatch, getState) => {
      const uid = getState().auth.uid
      const path = `scores/${uid}/${updatedScore.category}/${updatedScore.deviceType}`
      const scoreId = firebaseService.add(
        path,
        updatedScore,
        N.GAMERS,
      )
      dispatch({
        type: A.UPDATE_SCORE,
        scoreId,
        updatedScore,
      })
      dispatch(actions.updateCurrentGamerProfileWithScore())
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/scores.js